var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damage-validation view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: { numberOfStep: 3, textOfStep: _vm.$t("stepper.step3") },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown view_extend" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("damageValidation.title")))]),
        _c("p", { staticClass: "gray" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.text1"))),
        ]),
        _c("p", { staticClass: "gray mg mg--b-8" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.text2"))),
        ]),
        _c("div", { staticClass: "view_content_compensation" }, [
          _c(
            "div",
            { staticClass: "damage-validation_compensation" },
            [
              _c("h3", { staticClass: "headline-large-bold blueDark center" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.replaceDots(_vm.damagesImmobilier.compensation_base)
                    ) +
                    "€"
                ),
              ]),
              _c(
                "ma-accordion",
                { ref: "accordion" },
                [
                  _c("template", { slot: "accordionTop" }, [
                    _c("p", { staticClass: "accordion_title text-small" }, [
                      _vm._v(
                        _vm._s(_vm.$t("damageValidation.accordion.title"))
                      ),
                    ]),
                  ]),
                  _c(
                    "template",
                    { slot: "accordionBottom" },
                    [
                      _vm._l(
                        _vm.damagesImmobilier.descriptions,
                        function (damage) {
                          return _c("li", [
                            _c(
                              "p",
                              {
                                staticClass: "text-small-bold gray mg mg--t-1",
                              },
                              [_vm._v(_vm._s(damage.piece))]
                            ),
                            damage.finition
                              ? _c(
                                  "p",
                                  { staticClass: "text-small gray mg mg--t-1" },
                                  [
                                    _vm._v(
                                      _vm._s(damage.finition) +
                                        ", " +
                                        _vm._s(damage.surface)
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !damage.finition
                              ? _c(
                                  "p",
                                  { staticClass: "text-small gray mg mg--t-1" },
                                  [_vm._v(" " + _vm._s(damage.support))]
                                )
                              : _vm._e(),
                          ])
                        }
                      ),
                      _c(
                        "div",
                        { staticClass: "damage-validation_details mg mg--t-4" },
                        [
                          _c("p", { staticClass: "text-small-bold gray" }, [
                            _vm._v("Base d’indemnisation"),
                          ]),
                          _c("p", { staticClass: "text-small-bold gray" }, [
                            _vm._v(
                              _vm._s(
                                _vm.replaceDots(
                                  _vm.damagesImmobilier.compensation_base
                                )
                              ) + "€*"
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "content-material mg mg--t-4" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-small",
                              on: { click: _vm.handleOpenDescriptionModal },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "blueDark mg mg--r-1" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("damageValidation.accordion.title")
                                    )
                                  ),
                                ]
                              ),
                              _c("svgicon", {
                                attrs: {
                                  name: "question",
                                  color: "#005BA5",
                                  width: "12",
                                  height: "12",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "ma-modal",
                            {
                              ref: "modalDescription",
                              staticClass: "modal-confirmation",
                              attrs: { type: "small" },
                              on: {
                                "modal:close": _vm.handleCloseDescriptionModal,
                              },
                            },
                            [
                              _c("template", { slot: "modalContent" }, [
                                _c("div", { staticClass: "modal__main view" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "headline-medium center gray mg mg--b-5",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("damageValidation.modal.title")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "modal-subtitle headline-medium text-medium gray mg mg--b-5",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "damageValidation.modal.subtitle"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn mainBlue damage-validation_button",
                                      on: {
                                        click: _vm.handleCloseDescriptionModal,
                                      },
                                    },
                                    [
                                      _c("p", { staticClass: "text-medium" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "damageValidation.modal.close"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "report mg mg--t-4 mg--b-4 grid grid--middle" },
          [
            _c("p", { staticClass: "mg" }, [
              _vm._v(
                _vm._s(_vm.$t("damageValidation.description.pdfDownload"))
              ),
            ]),
            _c("svgicon", {
              staticClass: "mg",
              attrs: {
                icon: "ico-download",
                height: "24",
                width: "24",
                color: "#7E8994",
                "qa-downloadMaterialList-button": "",
              },
              on: { click: _vm.handleClickMaterialList },
            }),
          ],
          1
        ),
        _c("p", { staticClass: "gray" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.text3"))),
        ]),
        _c("p", { staticClass: "gray" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.text4"))),
        ]),
        _c("p", { staticClass: "gray" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.text5"))),
        ]),
      ]),
    ]),
    !_vm.hasMobilierTransition
      ? _c(
          "div",
          { staticClass: "view_actions" },
          [
            _c(
              "ma-buttons-next-actions",
              {
                staticClass: "buttonsNextActions",
                attrs: {
                  handleButtonClick: _vm.handlePrimaryButtonClick,
                  handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
                  title: _vm.$t("damageValidation.actions.primary"),
                  titleWhiteBtn: _vm.$t("damageValidation.actions.secondary"),
                  btnType: "functionalBtnWhite",
                },
              },
              [
                _vm.isE2EFlow
                  ? _vm._t("default", function () {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn ternaryWhite",
                            on: { click: _vm.handleTertiaryButtonClick },
                          },
                          [
                            _c("p", { staticClass: "text-medium" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("damageValidation.actions.tertiaryE2E")
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    })
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.hasMobilierTransition
      ? _c(
          "div",
          { staticClass: "view_actions" },
          [
            _c(
              "ma-buttons-next-actions",
              {
                staticClass: "buttonsNextActions",
                attrs: {
                  handleButtonClick: _vm.handlePrimaryButtonClickMobilier,
                  handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
                  title: _vm.$t("damageValidation.actions.gag.primary"),
                  titleWhiteBtn: _vm.$t(
                    "damageValidation.actions.gag.secondary"
                  ),
                  btnType: "functionalBtnWhite",
                },
              },
              [
                _vm.isE2EFlow
                  ? _vm._t("default", function () {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn ternaryWhite",
                            on: { click: _vm.handleTertiaryButtonClick },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "damageValidation.actions.gag.tertiary"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    })
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }